/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import * as Yup from 'yup';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { Card, Container } from '@material-ui/core';
import { useSnackbar } from 'notistack5';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useSettings from 'src/hooks/useSettings';
import CollectionDataForm from 'src/components/_dashboard/collection-data/CollectionDataForm';
//  redux
import { useDispatch, useSelector } from '../../redux/store';
import { getClientList, resetProjectListByClient } from '../../redux/slices/client';
import { resetCategoryListByProject } from '../../redux/slices/filecategory';
import { getMasterFileData } from '../../redux/slices/masterfile';
import {
  getExclusionRuleData,
  resetExclusionRuleSuccess,
  resetExclusionFileError
} from '../../redux/slices/exclusionrules';

CollectionData.propTypes = {
  isEdit: PropTypes.bool
};

export default function CollectionData({ isEdit }) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { masterFileData } = useSelector((state) => state.filemanager);
  const { exclusionRulesSetData, error, isError, success, isSuccess } = useSelector((state) => state.exclusionrules);

  useEffect(() => {
    dispatch(getClientList(true));
    dispatch(getMasterFileData());
    dispatch(getExclusionRuleData());
    dispatch(resetProjectListByClient());
    dispatch(resetCategoryListByProject());
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess && success) {
      enqueueSnackbar(success, {
        variant: 'success'
      });
      dispatch(getExclusionRuleData());
      dispatch(resetExclusionRuleSuccess());
    } else if (isError && error) {
      enqueueSnackbar(error, {
        variant: 'error'
      });
      dispatch(resetExclusionFileError());
    }
  }, [isError, isSuccess]);

  return (
    <Page title="Collection Data | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Collection Data"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Collection Data', href: PATH_DASHBOARD.general.columnmap }
          ]}
        />
        <Card>
          <CollectionDataForm EXCLUSION_RULE_OPTION={exclusionRulesSetData} SELECT_FILE_OPTION={masterFileData} />
        </Card>
      </Container>
    </Page>
  );
}
